import { writable } from 'svelte/store';
export let date = writable(new Date(new Date().setDate(new Date().getDate() + 1)));
export let night = writable(1);
export let guest = writable(2);
export let quantity = writable(1);
export let name = writable('');
export let type = writable(null);
export let price = writable('');
export let shoppingCategory = writable('');
// let store;
// export default store = {
//     data: {
//         date: { subscribe: date.subscribe },
//         night: { subscribe: night.subscribe },
//         guest: { subscribe: guest.subscribe },
//     },
// };
